import { writable } from "svelte/store";

const OPEN = true;
const CLOSED = false;

const createCartPopupOpenStore = () => {
    let current = CLOSED;
    const { subscribe, set } = writable(current);

    subscribe((v) => (current = v));

    const open = () => {
        set(OPEN);
    };
    const close = () => set(CLOSED);
    const toggle = () => (current === OPEN ? close() : open());
    return {
        subscribe,
        open,
        close,
        toggle,
    };
};

export const cartPopupOpen = createCartPopupOpenStore();
